export function colorAnd() {
	const walker = document.createTreeWalker(
		document.body,
		NodeFilter.SHOW_TEXT
	)

	const nodes = []

	while (walker.nextNode()) {
		if (walker.currentNode.nodeValue.includes('&')) {
			nodes.push(walker.currentNode)
		}
	}

	nodes.forEach((node) => {
		const span = document.createElement('span')
		span.innerHTML = node.nodeValue.replaceAll(
			'&',
			'<b style="color: var(--color-2);">&</b>'
		)

		node.replaceWith(...span.childNodes)
	})
}